// extracted by mini-css-extract-plugin
module.exports = {"form":"select_form__2TqBP","select":"select_select__2SMtU"};